module.exports = __webpack_public_path__ + "img/starseed-harmonies.cc237a79.png";